export default __webpack_public_path__ + "static/media/Requests_Hover.de406520.png";